import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { V2AdminService } from "../../../services/api/v2-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class InvoicesEffects {
	constructor(
		private actions$: Actions,
		private adminService: V2AdminService
	) {}

	getInvoices = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.invoices.getApi),
			switchMap(() =>
				this.adminService.invoices().pipe(
					map((invoices) => MpAdminActions.invoices.getSuccess({ invoices })),
					catchError((error) => of(MpAdminActions.invoices.getFail(new FailState(error))))
				)
			)
		)
	);

	createInvoice = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.invoices.createApi),
			switchMap(({ proposals }) =>
				this.adminService.createInvoice(proposals?.map((p) => p.proposalId) || []).pipe(
					map((invoiceCreationResponse) => {
						return MpAdminActions.invoices.createSuccess({ invoiceCreationResponse });
					}),
					catchError((error) => {
						return of(MpAdminActions.invoices.createFail(new FailState(error)));
					})
				)
			)
		)
	);

	sendInvoice = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.invoices.sendApi),
			switchMap(({ invoiceId }) =>
				this.adminService.sendInvoice(invoiceId).pipe(
					map((invoice) => MpAdminActions.invoices.sendSuccess({ invoice })),
					catchError((error) =>
						of(MpAdminActions.invoices.sendFail(new FailState(error)))
					)
				)
			)
		)
	);

	payInvoice = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.invoices.payApi),
			switchMap(({ invoiceId }) =>
				this.adminService.payInvoice(invoiceId).pipe(
					map((invoice) => MpAdminActions.invoices.paySuccess({ invoice })),
					catchError((error) => of(MpAdminActions.invoices.payFail(new FailState(error))))
				)
			)
		)
	);

	deleteInvoice = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.invoices.deleteApi),
			switchMap(({ invoiceId }) =>
				this.adminService.deleteInvoice(invoiceId).pipe(
					map(() => MpAdminActions.invoices.deleteSuccess({ invoiceId })),
					catchError((error) =>
						of(MpAdminActions.invoices.deleteFail(new FailState(error)))
					)
				)
			)
		)
	);

	loadBillableProposalsAfterInvoiceDelete$ = createEffect(() =>
		this.actions$.pipe(
			ofType(MpAdminActions.invoices.deleteSuccess),
			map(() => MpAdminActions.billableProposals.getApi())
		)
	);
}
